{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2017 - 2021                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSWEBUndo;

{$I WEBLib.TMSWEBDefines.inc}

interface

uses
  Classes, WEBLib.TMSWEBTypes;

type
  TTMSWEBUndoStackItem = class(TCollectionItem)
  private
    FActionName: string;
    FState: TStream;
    FObj: TObject;
  public
    constructor Create(Collection: TCollection); override;
    destructor Destroy; override;
    property ActionName: string read FActionName write FActionName;
    property Obj: TObject read FObj write FObj;
    property State: TStream read FState;
  end;

  TTMSWEBUndoManager = class(TCollection)
  private
    FCurrent: integer;
    FObject: TObject;
    FMaxStackCount: Integer;
    function GetStackItem(Index: Integer): TTMSWEBUndoStackItem;
  public
    function NextUndoAction: string;
    function NextRedoAction: string;
    function CanUndo: Boolean;
    function CanRedo: Boolean;
    procedure Undo;
    procedure Redo;
    procedure ClearUndoStack;
    procedure PushState(const {%H-}AActionName: string);
    constructor Create(AObject: TObject);
    property MaxStackCount: Integer read FMaxStackCount write FMaxStackCount default 20;
    property Stack[Index: Integer]: TTMSWEBUndoStackItem read GetStackItem; default;
  end;

implementation

uses
  SysUtils,
  WEBLib.TMSWEBPersistence;

{ TTMSWEBUndoStackItem }

constructor TTMSWEBUndoStackItem.Create(Collection: TCollection);
begin
  inherited Create(Collection);
  FState := TMemoryStream.Create;
end;

destructor TTMSWEBUndoStackItem.Destroy;
begin
  FState.Free;
  inherited;
end;

{ TTMSWEBUndoManager }

function TTMSWEBUndoManager.CanRedo: Boolean;
begin
  Result := (FCurrent < Count - 1) and (Count > 0);
end;

function TTMSWEBUndoManager.CanUndo: Boolean;
begin
  Result := (FCurrent > 0) and (Count > 0);
end;

procedure TTMSWEBUndoManager.ClearUndoStack;
begin
  Clear;
  FCurrent := -1;
  PushState('');
end;

constructor TTMSWEBUndoManager.Create(AObject: TObject);
begin
  inherited Create(TTMSWEBUndoStackItem);
  FObject := AObject;
  FMaxStackCount := 20;
  FCurrent := -1;
end;

function TTMSWEBUndoManager.GetStackItem(Index: Integer): TTMSWEBUndoStackItem;
begin
  Result := nil;
  if (Index > -1) and (Index < Count) then
    Result := TTMSWEBUndoStackItem(Items[Index]);
end;

function TTMSWEBUndoManager.NextUndoAction: string;
begin
  Result := '';
  if (FCurrent > -1) and (FCurrent < Count) then
    Result := TTMSWEBUndoStackItem(Items[FCurrent]).ActionName;
end;

function TTMSWEBUndoManager.NextRedoAction: string;
begin
  Result := '';
  if (FCurrent >= -1) and (FCurrent < Count - 1) then
    Result := TTMSWEBUndoStackItem(Items[FCurrent + 1]).ActionName;
end;

procedure TTMSWEBUndoManager.Undo;
var
  p: ITMSWEBPersistence;
begin
  if (FCurrent > 0) and (FCurrent <= Count) then
  begin
    with TTMSWEBUndoStackItem(Items[FCurrent - 1]) do
    begin
      FState.Position := 0;
      if Supports(FObject, ITMSWEBPersistence, p) then
        p.LoadSettingsFromStream(FState)
      else
        TTMSWEBPersistence.LoadSettingsFromStream(FObject, FState);
    end;
    Dec(FCurrent);
  end;
end;

procedure TTMSWEBUndoManager.Redo;
var
  p: ITMSWEBPersistence;
begin
  if (FCurrent >= -1) and (FCurrent < Count - 1) then
  begin
    with TTMSWEBUndoStackItem(Items[FCurrent + 1]) do
    begin
      FState.Position := 0;
      if Supports(FObject, ITMSWEBPersistence, p) then
        p.LoadSettingsFromStream(FState)
      else
        TTMSWEBPersistence.LoadSettingsFromStream(FObject, FState);
    end;
    Inc(FCurrent);
  end;
end;

procedure TTMSWEBUndoManager.PushState(const AActionName: string);
var
  p: ITMSWEBPersistence;
  it: TCollectionItem;
begin
  while FCurrent < Count - 1 do
  begin
    it := Items[Count - 1];
    it.Free;
  end;

  with TTMSWEBUndoStackItem(Add) do
  begin
    ActionName := AActionName;
    if Supports(FObject, ITMSWEBPersistence, p) then
      p.SaveSettingsToStream(FState)
    else
      TTMSWEBPersistence.SaveSettingsToStream(FObject, FState);
    Inc(FCurrent);
  end;
  if Count > MaxStackCount then
  begin
    Delete(0);
    dec(FCurrent);
  end;
end;

end.
